// Default State


export const state = {
    currentId: 0,
    loadMap: true
}





// WEBPACK FOOTER //
// ./src/store/state.js